module.exports = __webpack_public_path__ + "img/details-tips.cb5e94e.png";